import * as DKFDS from 'dkfds';
import $ from 'jquery';

$('a.nav-link[data-msg]').on('click', function () {
    if ($('.receipt').length > 0) return true;
    $('#topMenuModalText').html(this.dataset.msg);
    $('#topMenuModalTarget')
        .attr('href', this.href)
        .off('click')
        .on('click', () => $('#topMenuLoading').show());
    new DKFDS.Modal(document.getElementById('topMenuModal')).show();
    return false;
});